export default __webpack_public_path__ + "static/media/Ana.3f42df82.jpeg";